import React from "react";
import { X, Twitter, Facebook, MessageCircle, Copy, Download, Share2 } from "lucide-react";
import { toast } from "sonner";
import { socialLinks } from "@/lib/studioCanvas";

export default function ShareDialog({ open, onClose, shareUrl, dataUrl, caption }) {
  if (!open) return null;
  const links = shareUrl ? socialLinks(shareUrl, caption) : null;

  const copy = async () => {
    try { await navigator.clipboard.writeText(shareUrl); toast.success("Link copied"); }
    catch { toast.error("Copy failed"); }
  };
  const download = () => {
    const a = document.createElement("a");
    a.href = dataUrl || shareUrl;
    a.download = "aether-tryon.png";
    a.click();
  };
  const btn = (href, Icon, label, color) => (
    <a href={href} target="_blank" rel="noreferrer" data-testid={`share-${label.toLowerCase()}`}
       className="flex flex-col items-center gap-2 p-3 glass border border-white/10 hover:border-cyan transition-colors">
      <Icon className="w-5 h-5" style={{ color }} />
      <span className="font-mono text-[9px] tracking-widest text-slate-300">{label}</span>
    </a>
  );

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-app/80 backdrop-blur-sm p-5" data-testid="share-dialog" onClick={onClose}>
      <div className="relative w-full max-w-md glass-strong clip-chamfer brackets p-6" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-3 right-3 text-slate-400 hover:text-cyan" data-testid="share-close"><X className="w-5 h-5" /></button>
        <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] text-cyan/70 mb-3"><Share2 className="w-3.5 h-3.5" /> SHARE YOUR TRY-ON</div>
        {dataUrl && <img src={dataUrl} alt="Try-on" className="w-full border border-cyan/20 mb-4" />}
        <div className="grid grid-cols-3 gap-2 mb-2">
          {links && btn(links.twitter, Twitter, "X", "#1DA1F2")}
          {links && btn(links.facebook, Facebook, "Facebook", "#1877F2")}
          {links && btn(links.whatsapp, MessageCircle, "WhatsApp", "#25D366")}
        </div>
        <div className="grid grid-cols-2 gap-2">
          <button onClick={copy} data-testid="share-copy" className="flex items-center justify-center gap-2 p-3 glass border border-white/10 hover:border-cyan transition-colors font-mono text-[10px] tracking-widest text-slate-300"><Copy className="w-4 h-4 text-cyan" /> COPY LINK</button>
          <button onClick={download} data-testid="share-download" className="flex items-center justify-center gap-2 p-3 glass border border-white/10 hover:border-cyan transition-colors font-mono text-[10px] tracking-widest text-slate-300"><Download className="w-4 h-4 text-cyan" /> DOWNLOAD</button>
        </div>
      </div>
    </div>
  );
}
